var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.384 19.215c1.657-.845 8.104-4.528 8.104-10.727a8.488 8.488 0 00-16.977 0c0 6.2 6.447 9.882 8.104 10.727a.84.84 0 00.77 0zM12 14.55a6.063 6.063 0 100-12.126 6.063 6.063 0 000 12.126z",
    fill: "#00163E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.58 17.01a.96.96 0 011.343-.198c.873.648 1.525 1.527 1.525 2.59s-.652 1.942-1.525 2.59c-.88.654-2.084 1.155-3.448 1.492C15.1 23.824 13.558 24 12 24c-1.559 0-3.1-.176-4.475-.516-1.364-.337-2.567-.838-3.448-1.492-.873-.648-1.525-1.527-1.525-2.59s.652-1.942 1.525-2.59a.96.96 0 011.144 1.542c-.617.458-.75.834-.75 1.048 0 .214.133.59.75 1.048.609.452 1.55.87 2.765 1.17 1.207.3 2.593.46 4.014.46 1.421 0 2.807-.16 4.014-.46 1.216-.3 2.156-.718 2.765-1.17.617-.458.75-.834.75-1.048 0-.214-.133-.59-.75-1.048a.96.96 0 01-.199-1.343z",
    fill: "#00163E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.312 8.118h1.056c.286 0 .517-.088.695-.262.177-.182.266-.422.266-.72 0-.307-.089-.547-.266-.722-.171-.182-.403-.273-.695-.273h-1.056v1.977zm1.209 1.485h-1.219v2.784H9.8V4.646h2.72c.686 0 1.24.232 1.665.698.431.466.647 1.06.647 1.78 0 .735-.216 1.332-.647 1.791-.425.459-.98.688-1.664.688z",
    fill: "#00163E"
  })));
}
export default SvgParking;